import { useEffect, useState } from 'react';
import { analyticsService } from '@services';
import { getActiveAccountId, getSessionIdentity, getStoredToken } from '@helpers/auth';

// Keyed by identity because logout/login is a pure SPA transition with no reload — an
// unkeyed cache would leak the previous user's availability to the next one.
let cache = null;

const cacheKey = () => `${getSessionIdentity(getStoredToken())}:${getActiveAccountId() ?? ''}`;

/**
 * Availability of the Visibility Scanner for the current account.
 * Returns 'loading' until resolved, then true / false, or 'error' on a failed request.
 * A failure must not be treated as "disabled" — callers fail open so a transient outage
 * doesn't hide the section or redirect a deep link away.
 */
export const useVisibilityStatus = () => {
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const key = cacheKey();
        if (cache?.key !== key) {
            cache = { key, promise: analyticsService.getVisibilityStatus() };
        }
        const entry = cache;
        let active = true;
        entry.promise.then(
            data => {
                if (active) setStatus(Boolean(data?.enabled));
            },
            () => {
                if (cache === entry) cache = null;
                if (active) setStatus('error');
            },
        );
        return () => {
            active = false;
        };
    }, []);

    return status;
};
